import * as Sentry from '@sentry/electron/renderer'
import { LaunchDarklyRenderer } from '@renderer/utils/launchdarkly.renderer'
import WindowIpcRenderer from '@renderer/ipc/WindowIpc.renderer'
import { isMac } from '@shared/utils/platform'
import { viewIdentity, type ViewId } from './view-definitions'

export const POPOUT_WINDOWS_BY_DEFAULT_FLAG_KEY = 'popout-windows-by-default'

/**
 * Plain click opens a popout window; ⌘/Ctrl-click stays in the panel. Off by
 * default. Read at click time, not subscribed: `useViewActions` has dozens of
 * mounted callers and none of them needs to re-render when this flips.
 */
function popoutWindowsByDefault(): boolean {
  return LaunchDarklyRenderer.get<boolean>(POPOUT_WINDOWS_BY_DEFAULT_FLAG_KEY, false)
}

/**
 * ⌘-click (Ctrl on Windows) on a row opens its View in a window instead of the
 * panel. When `popoutByDefault` is on, that mapping inverts.
 */
export function isViewPopoutPointer(
  event: Pick<MouseEvent, 'metaKey' | 'ctrlKey'>,
  popoutByDefault = popoutWindowsByDefault(),
): boolean {
  const modifier = isMac ? event.metaKey : event.ctrlKey
  return popoutByDefault ? !modifier : modifier
}

/** Open a View in its own window, or focus the one already open for it. */
export function openViewWindow(view: { id: ViewId; context?: unknown }): void {
  void WindowIpcRenderer.openViewWindow({
    id: view.id,
    identity: viewIdentity(view),
    context: view.context,
  }).catch((error) => Sentry.captureException(error))
}
